export default "__VITE_ASSET__abd3a606__"